import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// import {
//   API_URL
// } from '../../../constants'

// Actions
import {
  createOrderEstimation,
  uploadFileToOrder
} from '../../../actions/orders'
import { createNote } from '../../../actions/notes'

// import styles
import './index.scss'

// Utils
import { hasSubscriptionPermission } from '../../../utils/auth'
import { translation } from '../../../utils/helpers'

// import components
import Modal from '../../components/Modal'
// import CircleImage from '../../components/CircleImage'
// import Gallery from '../../components/Gallery'

// import Portal from '../../components/Portal'
// import Confirm from '../../components/Confirm'

// Elements
import Textarea from '../../elements/textarea'

import { ModalIcons } from '../../elements/icons'

class RejectEvaluationModal extends Component {

  constructor (props) {
    super(props)
    this.state = this.resetState(props)
    this.createRejection = this.createRejection.bind(this)
    this.onInputChange = this.onInputChange.bind(this)

    this.onClose = this.onClose.bind(this)
  }

  resetState (props) {
    let newState = {
      confirm: false,
      isLoading: false,
      note: {
        NoteID: 0,
        Note: '',
        NoteTypeID: 1,
        OrderID: props.orderPrice !== undefined ? props.orderPrice.OrderId : 0,
        SourceID: 12,
        ApplyToInvoice: false,
        DeviationId: 0
      },
      overflowHidden: false
    }
    return newState
  }

  componentWillReceiveProps (nextProps) {
    this.setState(this.resetState(nextProps))
  }

  createRejection () {
    // e.preventDefault()
    this.setState({ isLoading: true })

    const createRejection = () => {
      let note = this.state.note
      this.props.createNote(note).then((res) => {
        // window.toastr.success(translation('13717'), translation('13424'))
        // this.props.router.replace({
        //   pathname: '/orders',
        //   query: {
        //     orderid: note.OrderID
        //   }
        // })
        this.props.goBack()
      }, () => {
        window.toastr.error(translation('1917'), translation('216'))
      })
      this.setState({ isLoading: false })
    }
    createRejection()
  }

  onInputChange (e) {
    let value = e.target.value
    let name = e.target.name
    if (name === 'Note') {
      this.setState({
        note: {
          ...this.state.note,
          [name]: value
        }
      }, () => {
        // console.log(this.state)
      })
    } else {
      this.setState({ [name]: value })
    }
  }

  renderStep1 () {
    return (
      <div>
        <Textarea labelText={translation('149')} name='Note' onChange={this.onInputChange} defaultValue={this.state.note.Note} />
      </div>
    )
  }

  onClose () {
    this.props.onClose()
  }

  render () {
    return (
      <div className='rejectestimation__modal'>
        <Modal
          {...this.props}
          header={translation('316')}
          overflowHidden={this.state.overflowHidden}
          clickOutsideClose={false}
          onClose={this.onClose}
          icon={ModalIcons.Estimation}
          bottomBarProps={{
            disabled: this.state.isLoading,
            actionLabelText: translation('791'),
            onActionClick: this.createRejection,
            cancelLabelText: translation('1155'),
            onCancelClick: this.onClose
          }}
        >
          {this.renderStep1()}
        </Modal>
      </div>
    )
  }
}

RejectEvaluationModal.propTypes = {
  createOrderEstimation: PropTypes.func.isRequired,
  uploadFileToOrder: PropTypes.func.isRequired,
  hasSubscriptionPermission: PropTypes.func.isRequired
}

export default connect(null, {
  createOrderEstimation,
  uploadFileToOrder,
  hasSubscriptionPermission,
  createNote
})(RejectEvaluationModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/RejectEvaluationModal/index.js